import { shallowRef } from 'vue';
import DOMPurify from 'isomorphic-dompurify';
import type { AfterSubmitPayload } from '@nuxt-features/form-pers-consultation';

export const ANALYTICS_SUBSCRIPTION_SID = 'subscribe_analytics_non_qualified';

export const useAnalyticsSubscriptionModel = () => {
  const message = shallowRef<AfterSubmitPayload | null>(null);

  const handleSubmit = (payload: AfterSubmitPayload) => {
    message.value = {
      ...payload,
      title: DOMPurify.sanitize(payload.title),
      description: DOMPurify.sanitize(payload.description),
    };
  };

  const closeMessage = () => {
    message.value = null;
  };

  return { message, handleSubmit, closeMessage };
};
